import classNames from 'classnames';
import { FC, HTMLAttributes } from 'react';

import style from './text-base.module.css';

type FontColor = 'black' | 'inherit' | 'iris' | 'turquoise' | 'white';
type FontSize = 12 | 14 | 15 | 16 | 18 | 20 | 22 | 24 | 30 | 32 | 36 | 38 | 48 | 70;
type FontWeight = 300 | 400 | 700;
type TextElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';

export interface TextProps {
  as?: TextElement;
  fontColor?: FontColor;
  fontSize?: FontSize;
  fontWeight?: FontWeight;
  uppercase?: boolean;
}

type Props = HTMLAttributes<HTMLParagraphElement> & Required<TextProps>;

export const fontColorMap: Record<FontColor, string> = {
  black: style.fontColorBlack,
  inherit: style.fontColorInherit,
  iris: style.fontColorIris,
  turquoise: style.fontColorTurquoise,
  white: style.fontColorWhite,
};

export const fontSizeMap: Record<FontSize, string> = {
  [12]: style.fontSize12,
  [14]: style.fontSize14,
  [15]: style.fontSize15,
  [16]: style.fontSize16,
  [18]: style.fontSize18,
  [20]: style.fontSize20,
  [22]: style.fontSize22,
  [24]: style.fontSize24,
  [30]: style.fontSize30,
  [32]: style.fontSize32,
  [36]: style.fontSize36,
  [38]: style.fontSize38,
  [48]: style.fontSize48,
  [70]: style.fontSize70,
};

export const fontWeightMap: Record<FontWeight, string> = {
  [300]: style.fontWeight300,
  [400]: style.fontWeight400,
  [700]: style.fontWeight700,
};

const TextBase: FC<Props> = ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  as: Element,
  fontColor = 'inherit',
  fontSize,
  fontWeight,
  uppercase,
  ...props
}) => {
  return (
    <Element
      {...props}
      className={classNames(
        fontColorMap[fontColor],
        // Prevents overriding fontSize class. Example is when trying to apply `fontSize12` to `Paragraph` component.
        // We do this in the disclaimer section of the `BenefitsList` component.
        !props.className?.includes('fontSize') && fontSizeMap[fontSize],
        fontWeightMap[fontWeight],
        uppercase ? style.uppercase : '',
        props.className,
      )}
    />
  );
};

export default TextBase;
